<template>
<v-layout>
  <v-flex xs10 offset-xs1>
  <v-card>
    <v-card-title>
      <v-btn color="info" href="#/advertiser/add" @click="goToAdd()">Add Advertiser</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="advertiserList"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.advertiserId }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.country }}</td>
        <td class="text-xs-center">{{ props.item.status? 'Active' : 'Inactive' }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteAdvertiser(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Sorry!!! No result found for your search "{{ search }}".
      </v-alert>
    </v-data-table>
  </v-card>
  </v-flex>

  <v-flex>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title">Do you want to change the status of the advertiser?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" outline @click.native="deleteDialog = false; selectedAdvertiser = null">Cancel</v-btn>
          <v-btn color="primary" outline @click.native="deleteConfirmed()"> Change </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>

  </v-layout>
</template>
<script>
import axios from "axios";
import { SERVER_URL } from "./../../constant.js";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Adv. ID",
          value: "advertiserId",
          align: "left"
        },
        {
          text: "Name",
          value: "name",
          align: "left"
        },
        {
          text: "Country",
          align: "left",
          value: "country",
          sortable: false
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false
        }
      ],
      countries: [],
      advertiserList: [],

      deleteDialog: false,
      selectedAdvertiser: null
    };
  },
  created() {
    document.title = 'Advertisers';
    axios.get(`${SERVER_URL}/advertiser/all`).then(res => {
      this.advertiserList = res.data;
    });
  },
  methods: {
    goToAdd() {
      this.$router.push("/advertiser/add");
    },
    deleteAdvertiser(advertiser) {

      this.selectedAdvertiser = advertiser;
      this.deleteDialog = true;

    },
    deleteConfirmed() {
      
      let advertiser = this.selectedAdvertiser;
      advertiser.status = ! advertiser.status;
      this.deleteDialog = false;
      axios
      .post(`${SERVER_URL}/advertiser/update`, advertiser)
      .then(res => {



        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Advertiser Deleted Successfully"
        });
        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = this.advertiserList.findIndex(
          adv =>
            adv.advertiserId === advertiser.advertiserId
        );
        this.$set(this.advertiserList, changedIndex, advertiser);
        this.selectedAdvertiser = null;
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/advertiser/ListAdvertisers.vue